export default __webpack_public_path__ + "static/media/Angry.f958a02e.png";